import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { PeerReviewerResponse } from '../../models/super-admin/peerReviewerResponse';
import { UserStateModel } from '../../states/user/user-state-model';
import { PeerTimingResponse, TimeSlot } from '../../models/peer/peerTimingResponse';
import { MentorService } from '../../services/account/mentor.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { PeerReviewService } from '../../services/peer-review/peer-review.service';
import { SchedulePeerCallService } from '../../services/schedule-peer-call/schedule-peer-call.service';
import { Store } from '@ngxs/store';
import { Gender, GenderDescriptions } from '../../models/enums/enums';
import { UserSelectors } from '../../states/user/user-selector';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-schedule-peer-call',
  standalone: true,
  imports: [FormsModule, CommonModule,CalendarModule, DropdownModule, DialogModule, ButtonModule],
  templateUrl: './schedule-peer-call.component.html',
  styleUrl: './schedule-peer-call.component.scss'
})
export class SchedulePeerCallComponent {
  visible: boolean = false;
    index: number | undefined;
  
      showDialog(index? : number) {
        this.visible = true;
        if(index != undefined){
        this.index = index;
        }
      }
  
    date: Date | undefined;
    formattedDate: string = '';
    mindate: Date = new Date();

    peerDetail: PeerReviewerResponse | undefined;
    mentorId: string | undefined;
    user: UserStateModel | undefined;
    genders: { name: string; value: number }[] = [];
    timeslots: { id: number, from: string }[] = [];
    purpose: string = 'Requesting GradPilots Peer Meeting';
  
    constructor(private mentorService: MentorService,
      private messageService: MessageService,
      private route: ActivatedRoute,
      private peerReviewService: PeerReviewService,
      private schedulePeerCallService: SchedulePeerCallService,
      private store: Store
    ) {
      this.mentorId = this.route.snapshot.paramMap.get('id') || '';
    }
  
   
  
    ngOnInit(): void {
      this.getPeerReviwer();
      this.getUser();
      this.genders = [
        { name: 'Male', value: 1 },
        { name: 'Female', value: 2 },
        { name: 'Other', value: 3 }
      ]
    }
  
    onDateSelect(event: any) {
      this.date = event;
      this.formattedDate = this.formatDateForBackend(this.date);
      this.generateTimeSlots();
    }
    formatDateForBackend(date: Date | undefined): string {
      if (!date) {
        return ''; // Or handle the case where date is undefined
      }
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  
    getPeerReviwer(){
      this.peerReviewService.getPeerReviewerById(this.mentorId).subscribe({
        next: response => {
          this.peerDetail = response;
          if (this.date) {
            this.generateTimeSlots();
          }
        },
        error: err => {
          console.error(err);
        }
      })
    }

  getUser() {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.user = response;
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }
  
    generateTimeSlots() {
      this.timeslots = [];
      let id = 1;
      for (let hour = 9; hour <= 18; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
           const period = hour >= 12 ? 'PM' : 'AM';
           const displayHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);
           const displayMinute = minute === 0 ? '00' : '30';
           const timeString = `${displayHour.toString().padStart(2, '0')}:${displayMinute} ${period}`;
           this.timeslots.push({ id: id++, from: timeString });
        }
      }
    }
  
    // getPeerTimings() {
    //   if (this.peerDetail) { 
    //     this.peerTimingsService.getPeerTimings({
    //       peerId: this.peerDetail.applicationUserId,
    //       day: this.date!.getDay()
    //     }).subscribe({
    //       next: (response) => {
    //         this.peerTimings = response;
    //         this.timeslots = response.availability;
    //       },
    //       error: (err) => {
    //         console.warn('Error fetching peer timings:', err);
    //       }
    //     });
    //   }
    // }
    selectedSlots: { date: Date, formattedDate: string, slot: { id: number, from: string } }[] = [];

    toggleSlot(slot: { id: number, from: string }) {
      const existingIndex = this.selectedSlots.findIndex(s => s.slot.id === slot.id && s.formattedDate === this.formattedDate);
      if (existingIndex > -1) {
        this.selectedSlots.splice(existingIndex, 1);
      } else {
        if (this.selectedSlots.length < 3) {
          this.selectedSlots.push({
            date: new Date(this.date!),
            formattedDate: this.formattedDate,
            slot: slot
          });
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Limit Reached', detail: 'You can select up to 3 preferred slots.' });
        }
      }
    }

    removeSlot(index: number) {
      this.selectedSlots.splice(index, 1);
    }

    isSlotSelected(slot: { id: number, from: string }): boolean {
      return this.selectedSlots.some(s => s.slot.from === slot.from && s.formattedDate === this.formattedDate);
    }
  
    addScheduleCall() {
      if (this.selectedSlots.length === 0) return;

      const requests = this.selectedSlots.map(s => 
        this.schedulePeerCallService.addScheduleCall({
          studentId: this.user!.id,
          peerReviewerId: this.peerDetail!.applicationUserId,
          purpose: this.purpose,
          date: s.formattedDate,
          time: s.slot.from
        })
      );

      forkJoin(requests).subscribe({
        next: (responses) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Schedule Call request sent successfully!' });
          this.selectedSlots = [];
          this.purpose = '';
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to send all requests.' });
        }
      });
    }
  
    genderDescriptions(arg0: Gender | undefined): string {
      if (arg0) {
        return GenderDescriptions[arg0];
      }
      else {
        return '';
      }
    }
  
    // initilizeCalendly() {
    //   this.store.select(UserSelectors.getUser).pipe(switchMap(user => {
    //     if (!user || !user.id) {
    //       return of(null);
    //     }
    //     this.user = user;
    //     return this.mentorService.getMentorScheduleURI(this.mentorId??'');
    //   })).subscribe({
    //     next: response => {
    //       if (response != null && response!='') {
    //         window.Calendly.initInlineWidget({
    //           url: `${response}/30min?hide_gdpr_banner=1`,
    //           parentElement: document.querySelector('.calendly-inline-widget'),
    //           prefill: {
    //             "name": this.user?.firstName + ' ' + this.user?.lastName,
    //             "email": this.user?.email,
    //             "customAnswers": {
    //               "a1": "GradPilots Mentor Meeting",
    //             }
    //           }
    //         });
    //       }
    //     }
    //   });
    // }
}
